import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { regionsURL, regionURL } from '@admin/config/routes';

interface IBreadcrumbsProps {
  name: string;
  regionId?: string | number;
  edit?: boolean;
}

export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ name, regionId, edit }) => (
  <Breadcrumb>
    <Breadcrumb.Item>
      <NavLink to={regionsURL()} className="text-primary">
        {' '}
        Regions{' '}
      </NavLink>
    </Breadcrumb.Item>
    {name &&
      (edit ? (
        <>
          <Breadcrumb.Item>
            <NavLink to={regionURL({ id: regionId! })} className="text-primary">
              {name}
            </NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Edit</Breadcrumb.Item>
        </>
      ) : (
        <Breadcrumb.Item active>{name}</Breadcrumb.Item>
      ))}
  </Breadcrumb>
);
